import { useMutation } from '@apollo/client/react';

import { createSpeechToTextTokenPort } from '@/shared-responder-v2';
import type { SpeechToTextTokenPort } from '@/shared-responder-v2-core';
import { GET_ASSEMBLYAI_TOKEN } from '@/survey-graphql';

// test-exception: Apollo binding only — the token request and result mapping are createSpeechToTextTokenPort, covered by shared-responder-v2-speech-to-text-token.spec.ts.
export function useSurveySpeechToTextTokenPort(): SpeechToTextTokenPort {
  const [getAssemblyAiToken] = useMutation(GET_ASSEMBLYAI_TOKEN);

  return createSpeechToTextTokenPort(async (input) => {
    const { data } = await getAssemblyAiToken({ variables: { input } });

    return data?.assemblyAIToken;
  });
}
